import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import 'antd/dist/reset.css';

import AppRoutes from './components/Routes/AppRoutes';
import LogIn from './pages/Auth/login';
import Invitation from './pages/Invitation/Invitation';
import { isAuthenticated } from './utilities/authentication';

const RootRouter = () => {
  if (!isAuthenticated()) {
    return <LogIn />;
  }

  return <AppRoutes />;
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/invite/:token' element={<Invitation />} />
          <Route path='/*' element={<RootRouter />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
